import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Bowser from 'bowser';
import { PLATFORMS_MAP } from 'bowser/src/constants';
import Header from '../Header';
import TransactionsTable from '../TransactionsTable';
import BottomPanel from '../BottomPanel';

import styles from './Main.module.css';
import Filter from '../Filter';
import MobilePopup from '../MobilePopup';

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMobileConfirmation: true,
    };
  }

  componentDidMount() {
    const parsedBrowserInfo = Bowser.parse(window.navigator.userAgent);
    const isDesktop = parsedBrowserInfo.platform.type === PLATFORMS_MAP.desktop;
    if (isDesktop) {
      this.confirmUsageOnMobile();
    }
  }

  confirmUsageOnMobile = () => {
    this.setState({ showMobileConfirmation: false });
  }

  render() {
    const { account } = this.props;
    if (account == null) return null;
    const { showMobileConfirmation } = this.state;
    if (showMobileConfirmation) {
      return <MobilePopup onOkClick={this.confirmUsageOnMobile} />;
    }
    return (
      <div className={styles.Main}>
        <Header />
        <div className={styles.Body}>
          <div className={styles.SidePanel}>
            <Filter />
            <BottomPanel />
          </div>
          <div className={styles.Content}>
            {account && <TransactionsTable />}
          </div>
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  match: PropTypes.shape({}).isRequired,
  account: PropTypes.shape({}),
};

Main.defaultProps = {
  account: null,
};

const mapStateToProps = ({ accountService }) => ({
  account: accountService.account,
});

export default withRouter(connect(mapStateToProps, {})(Main));
